/**
 * Schedule-related enums for the frontend
 */

// Schedule Status Enum
export enum ScheduleStatus {
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED'
}

// Schedule Status Labels
export const ScheduleStatusLabels: Record<ScheduleStatus, string> = {
  [ScheduleStatus.INACTIVE]: 'INACTIVE',
  [ScheduleStatus.ACTIVE]: 'ACTIVE',
  [ScheduleStatus.COMPLETED]: 'COMPLETED',
  [ScheduleStatus.CANCELLED]: 'CANCELLED'
};

// Activity Status Enum
export enum ActivityStatus {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  PAUSED = 'PAUSED',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
  BREACHED = 'BREACHED'
}

// Activity Status Labels
export const ActivityStatusLabels: Record<ActivityStatus, string> = {
  [ActivityStatus.PENDING]: 'PENDING',
  [ActivityStatus.IN_PROGRESS]: 'IN_PROGRESS',
  [ActivityStatus.PAUSED]: 'PAUSED',
  [ActivityStatus.COMPLETED]: 'COMPLETED',
  [ActivityStatus.CANCELLED]: 'CANCELLED',
  [ActivityStatus.BREACHED]: 'BREACHED'
};

// Activity SLA Status Enum
export enum ActivitySLAStatus {
  ON_TIME = 'ON_TIME',
  AT_RISK = 'AT_RISK',
  BREACHED = 'BREACHED'
}

// Activity SLA Status Labels
export const ActivitySLAStatusLabels: Record<ActivitySLAStatus, string> = {
  [ActivitySLAStatus.ON_TIME]: 'ON_TIME',
  [ActivitySLAStatus.AT_RISK]: 'AT_RISK',
  [ActivitySLAStatus.BREACHED]: 'BREACHED'
};

// Helper functions
export const getScheduleStatusLabel = (status: ScheduleStatus): string => {
  return ScheduleStatusLabels[status] || status;
};

export const getActivityStatusLabel = (status: ActivityStatus): string => {
  return ActivityStatusLabels[status] || status;
};

export const getActivitySLAStatusLabel = (status: ActivitySLAStatus): string => {
  return ActivitySLAStatusLabels[status] || status;
};

// Helper function to check if schedule is active
export const isScheduleActive = (status: ScheduleStatus): boolean => {
  return status === ScheduleStatus.ACTIVE;
};

// Helper function to check if schedule can be edited
export const canEditSchedule = (status: ScheduleStatus): boolean => {
  return status === ScheduleStatus.INACTIVE || status === ScheduleStatus.ACTIVE;
};

// Helper function to check if schedule can be deleted
export const canDeleteSchedule = (status: ScheduleStatus): boolean => {
  return status === ScheduleStatus.INACTIVE;
};